import script from "./PackageDetailsTooltip.vue?vue&type=script&setup=true&lang=ts"
export * from "./PackageDetailsTooltip.vue?vue&type=script&setup=true&lang=ts"

import "./PackageDetailsTooltip.vue?vue&type=style&index=0&id=33c4a3e7&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33c4a3e7"]])

export default __exports__